'use client';

import { CSSProperties, FC } from 'react';

interface HeroProps {
  backgroundImage: string;
  title: string;
  subtitle: string;
  paddingStyle?: CSSProperties;
}

const HeroSection: FC<HeroProps> = ({ backgroundImage, title, subtitle, paddingStyle }) => {
  return (
    <div
      className="relative m-0 flex w-full items-center justify-center overflow-hidden rounded-b-4xl bg-cover bg-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        ...paddingStyle,
      }}
    >
      <div className="absolute inset-0 bg-white opacity-70" />

      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center">
        <h1 className="text-3xl font-bold text-black @sm:text-4xl @md:text-5xl">{title}</h1>
        <p className="mt-4 text-center text-base text-black @sm:text-lg @md:text-xl">{subtitle}</p>
      </div>
    </div>
  );
};

export default HeroSection;
